import { Table, Button, Badge } from 'react-bootstrap'
import { KYC_STATUSES, KYC_STATUSES_COLOR_LIGHT, KYC_STATUSES_TEXT_COLOR } from '../constants'
import moment from 'moment'

const KYCTable = ({ kyc, setSelectedKYCUser, setKYCUserModalVisible }) => {
  return (
    <Table responsive bordered className="text-center">
      <thead>
        <tr>
          <th>รหัสลูกค้า</th>
          <th>เบอร์โทรศัพท์</th>
          <th>วันที่สมัคร</th>
          <th>สถานะบัตรประชาชน</th>
          <th>สถานะบัญชีธนาคาร</th>
          <th>สถานะการตรวจสอบ</th>
        </tr>
      </thead>
      <tbody>
        {kyc.length > 0 ? (
          kyc.map((kyc, i) => {
            return (
              <tr key={i}>
                <td>{kyc.user.userNo || '-'}</td>
                <td>{kyc.user.phone || '-'}</td>
                <td>{kyc.createdAt ? moment(kyc.createdAt).format('DD/MM/YYYY') : '-'}</td>
                <td>
                  {kyc.cardInfo.status ? (
                    <Badge className={KYC_STATUSES_TEXT_COLOR[kyc.cardInfo.status]}>{kyc.cardInfo.status}</Badge>
                  ) : (
                    '-'
                  )}
                </td>
                <td>
                  {kyc.bookBankInfo.status ? (
                    <Badge className={KYC_STATUSES_TEXT_COLOR[kyc.bookBankInfo.status]}>
                      {kyc.bookBankInfo.status}
                    </Badge>
                  ) : (
                    '-'
                  )}
                </td>
                <td>
                  {kyc.status === KYC_STATUSES.PENDING ? (
                    <Button
                      size="sm"
                      variant={KYC_STATUSES_COLOR_LIGHT[kyc.status]}
                      style={{ borderColor: KYC_STATUSES_TEXT_COLOR[kyc.status] }}
                      onClick={() => {
                        if (kyc.status === KYC_STATUSES.PENDING) {
                          setSelectedKYCUser(kyc)
                          setKYCUserModalVisible(true)
                        }
                      }}
                    >
                      <span style={{ fontWeight: 'bold', fontSize: '14px' }}>{kyc.status}</span>
                    </Button>
                  ) : (
                    <Badge
                      variant={KYC_STATUSES_COLOR_LIGHT[kyc.status]}
                      style={{ borderColor: KYC_STATUSES_TEXT_COLOR, padding: '6px 10px' }}
                      onClick={() => {
                        if (kyc.status === KYC_STATUSES.PENDING) {
                          setSelectedKYCUser(kyc)
                          setKYCUserModalVisible(true)
                        }
                      }}
                    >
                      {kyc.status}
                    </Badge>
                  )}
                </td>
              </tr>
            )
          })
        ) : (
          <tr>
            <td colSpan="6" style={{ textAlign: 'center' }}>
              ไม่พบข้อมูล
            </td>
          </tr>
        )}
      </tbody>
    </Table>
  )
}

export default KYCTable
